// extracted by mini-css-extract-plugin
module.exports = {"ball_pulse":"Loader_ball_pulse__RB2qO","scale":"Loader_scale__Z9rCb","loader":"Loader_loader__7ZWW3"};